const FilterOperator = {
    In: "In",
    GreaterThan: "GreaterThan",
    LessThan: "LessThan",
    GreaterThanOrEqual: "GreaterThanOrEqual",
    LessThanOrEqual: "LessThanOrEqual",
    Equal: "Equal",
    NotEqual: "NotEqual",
    Exists: "Exists",
    DoesNotExist: "DoesNotExist"
};

export default FilterOperator;



// WEBPACK FOOTER //
// ./public/classes/FilterOperators.js